<template>
    <div class="row mb-3">
        <h2 v-if="fieldData.type === 'h2'" class="col-12">{{ field.value }}</h2>
        <h3 v-if="fieldData.type === 'h3'" class="col-12">{{ field.value }}</h3>
        <h4 v-if="fieldData.type === 'h4'" class="col-12">{{ field.value }}</h4>
        <h5 v-if="fieldData.type === 'h5'" class="col-12">{{ field.value }}</h5>
        <h6 v-if="fieldData.type === 'h6'" class="col-12">{{ field.value }}</h6>
        <p v-if="fieldData.type === 'Text'" class="col-12">{{ field.value }}</p>
    </div>
</template>

<script>
export default {
    props: {
        field: {
            type: Object,
            required: true
        },
        value: {
            type: String,
            required: false,
            defaultValue: ''
        },
        fieldCols: {
            type: String,
            required: true
        },
        labelCols: {
            type: String,
            required: true
        }
    },
    computed: {
        fieldData() {
            let parsedFieldData = {
                type: 'Text'
            }
            if (this.field.data !== '') {
                parsedFieldData = JSON.parse(this.field.data);
            }

            return parsedFieldData;
        }
    }
}
</script>